import { Svg } from "@impero-com/ui";

import { DrawerHeaderLabel } from "components/drawerHeaderLabel/drawerHeaderLabel";

import * as theme from "./theme.css";
import { FieldTypeInfo } from "./utils";
interface FieldDrawerHeaderProps {
    fieldTypeInfo: FieldTypeInfo;
}

export function FieldDrawerHeader({ fieldTypeInfo }: FieldDrawerHeaderProps) {
    return (
        <div className={theme.fieldDrawerHeader}>
            <Svg
                src={fieldTypeInfo.svg}
                className={theme.fieldDrawerHeaderIcon}
            />
            <DrawerHeaderLabel label={fieldTypeInfo.label} />
        </div>
    );
}
